export const jazzzoImageURL = "https://pbs.twimg.com/profile_images/1736294840478879744/sk_PK6jF_400x400.jpg"
export const xURL = "https://twitter.com/jazzzo__"